import styled from "styled-components";
import chroma from "chroma-js";

export const SkillsList = styled.ul`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;
`;

export const Skill = styled.li`
    min-height: 1.625rem;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem; 
    margin: 0 0.3125rem 0.3125rem 0;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    &:not(.show-more) {
        padding: .5rem;
        background: #F5EDFF;
        border: 1px solid transparent;
    }
`;

export const Tag = styled(Skill)<{color: string}>`
    background-color: ${(props) => chroma(props.color).alpha(0.2).hex()} !important;
    color: ${(props) => props.color};
`;

export const ShowMore = styled.button`
    background: #FFFFFF;
    font-size: .75rem;
    border: 0.5px solid ${({ theme }) => theme.colors.primaryBlue.main};
    border-radius: 0.3125rem;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    position: relative;
    height: 1.625rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    margin-top: .5rem;
    width: fit-content;

    img {
        position: absolute;
        content: "";
        right: 5px;

    }
`;
